import ReactHelmet from "react-helmet";
import { useTranslation } from "react-i18next";

const legalLinks = [
  {
    key: "Bullet1",
    href: "/legal/terms-of-service-en-202606.pdf",
  },
  {
    key: "Bullet7",
    href: "/legal/product-schedule-property-bill-payment-services-en-202606.pdf",
  },
  {
    key: "Bullet2",
    href: "https://legal.sendola.io/Legal_Policies/privacy-policy-en-202507.pdf",
  },
  {
    key: "Bullet3",
    href: "https://legal.sendola.io/Legal_Policies/data-retention-policy-en-202507.pdf",
  },
  {
    key: "Bullet4",
    href: "https://legal.sendola.io/Legal_Policies/data-security-policy-en-202507.pdf",
  },
  {
    key: "Bullet5",
    href: "https://legal.sendola.io/Legal_Policies/disclosure-electronic-communications-en-202507.pdf",
  },
  {
    key: "Bullet6",
    href: "https://legal.sendola.io/Legal_Policies/usa-patriot-act-notice-en-202507.pdf",
  },
];

export const HomeownersLegalPage = () => {
  const [t] = useTranslation("homeowners");

  return (
    <>
      <ReactHelmet>
        <title>{t("Legal.SEOTitle")}</title>
      </ReactHelmet>

      <div className="flex flex-col gap-6 w-full min-h-full bg-homeowners-bg px-6 sm:px-12 lg:px-24 xl:px-32 pt-28 lg:pt-32 pb-40">
        <h1 className="font-playfair font-bold text-homeowners-headline text-[clamp(1.75rem,1.2rem+1.4vw,3rem)]">
          {t("Legal.Title")}
        </h1>
        <p className="font-montserrat text-homeowners-gray text-[clamp(0.875rem,0.75rem+0.3vw,1.125rem)]">
          {t("Legal.Address")}
        </p>
        <ul className="flex flex-col gap-3 pl-4 list-disc">
          {legalLinks.map(({ key, href }) => (
            <li key={key}>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="font-montserrat font-semibold text-homeowners-purple underline text-[clamp(0.875rem,0.75rem+0.3vw,1.125rem)] hover:opacity-80 transition-opacity"
              >
                {t(`Legal.${key}`)}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
